import { render } from "./ed-organism-enquiry-list-small.vue?vue&type=template&id=9508daf8"
import script from "./ed-organism-enquiry-list-small.vue?vue&type=script&lang=js"
export * from "./ed-organism-enquiry-list-small.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__